import dayjs from "dayjs"

import { INCOGNITO_MASK } from "../../../../../Components/Private"
import { isIncognitoActive } from "../../../../../Utils/incognito"
import { baseOptions } from "../../../../DashboardPage/components/chartsOptions"
import { formatCount } from "../../../utils/formatNumber"
import { formatRate } from "../../utils/formatNumber"

const dateFormat = "MMM D, YYYY"

export const getChartOptions = (theme, setTooltip, dataType) => ({
  ...baseOptions(theme),
  scales: {
    x: {
      ...baseOptions(theme).scales.x,
      ticks: {
        color: "#7A7A83",
        font: {
          size: 12,
          weight: 400
        }
      }
    },
    y: {
      type: "linear",
      //grace: 100,
      // display: showFilteredTrafficScale,
      display: true,
      position: "left",
      beginAtZero: true,
      grid: {
        color: theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "#E1E1E2",
        tickColor: "transparent"
      },
      border: {
        display: false,
        dash: [4, 4]
      },
      ticks: {
        maxTicksLimit: 6,
        font: {
          size: 12,
          weight: 400
        },
        color: "#7A7A83",
        callback: function (value) {
          // The rate scale is masked in Incognito mode; the Count view keeps its axis readable
          // (CHA1-1357). Drawn outside React, hence the live `isIncognitoActive` mirror.
          if (dataType === "rate") return isIncognitoActive() ? INCOGNITO_MASK : formatRate(value)
          return formatCount(value)
        }
      }
    }
  },
  plugins: {
    "vertical-line-plugin-with-points": { theme: theme },
    tooltip: {
      // Disable the on-canvas tooltip
      enabled: false,
      external: function (context) {
        const tooltipModel = context.tooltip
        if (tooltipModel.opacity === 0) {
          setTooltip({ visible: false })
          if (context.chart.canvas._hideOnTouchOutside) {
            document.removeEventListener("touchstart", context.chart.canvas._hideOnTouchOutside)
            context.chart.canvas._hideOnTouchOutside = null
          }
          return
        }

        const position = context.chart.canvas.getBoundingClientRect()

        const dataPoint = context.tooltip.dataPoints?.[0]
        const dataIndex = dataPoint?.dataIndex

        const mainDataset = context.chart.data.datasets.find((d) => Array.isArray(d.mainLabels))
        const rawMainDate = mainDataset?.mainLabels?.[dataIndex] ?? dataPoint?.label

        const currentPoints = context.chart.data.datasets.map((dataset) => {
          const rawCompDate = dataset.comparisonLabels?.[dataIndex]
          return {
            value: dataset.data[dataIndex],
            datasetType: dataset.datasetType,
            backgroundColor: dataset.borderColor,
            label: dataset.label,
            dashed: Array.isArray(dataset.borderDash) && dataset.borderDash.length > 0,
            comparisonDate: rawCompDate ? dayjs(rawCompDate).format(dateFormat) : null
          }
        })

        const payload = {
          visible: true,
          x: position.left + window.pageXOffset + tooltipModel.caretX,
          y: position.top + window.pageYOffset + tooltipModel.caretY,
          date: rawMainDate ? dayjs(rawMainDate).format(dateFormat) : null,
          data: currentPoints
        }
        setTooltip(payload)

        if (!context.chart.canvas._hideOnTouchOutside) {
          const canvas = context.chart.canvas
          canvas._hideOnTouchOutside = (e) => {
            if (!canvas.contains(e.target)) {
              setTooltip({ visible: false })
              document.removeEventListener("touchstart", canvas._hideOnTouchOutside)
              canvas._hideOnTouchOutside = null
            }
          }
          document.addEventListener("touchstart", canvas._hideOnTouchOutside, {
            passive: true
          })
        }
      }
    },
    legend: {
      display: false
    }
  }
})

export const datasetsOptions = {
  fraud_rate: {
    label: "Fraud rate",
    borderColor: "#225AEA",
    borderWidth: 2,
    datasetType: "fraud_rate"
  },
  vamp_rate: {
    label: "VAMP rate",
    borderColor: "#35BD29",
    borderDash: [4, 4],
    borderWidth: 2,
    datasetType: "vamp_rate"
  },
  vamp_zone: {
    label: "VAMP zone",
    borderColor: "#D71313",
    borderWidth: 2,
    datasetType: "vamp_zone"
  },
  dispute_rate: {
    label: "Dispute rate",
    borderColor: "#DF7009",
    borderWidth: 2,
    datasetType: "dispute_rate"
  }
}
